import { DeleteOutlined } from "@ant-design/icons";
import SortIcon from "../../../global/components/SortIcon";
import { Tooltip } from "antd";
import { formatUTCTime } from "../../../global/utils/unixToLocalTime";
import { isPurchasePaid, renderPrice } from "../../../utils/Common";

export const PurchaseColumns = (
  hoveredRow,
  setShowModal,
  setSelectedRowKeys,
  setParams,
  params,
  hideColmn,
) => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {};
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);
  const canManagePurchase = [1, 2].includes(loggedInUser?.role_value);
  return [
    {
      title: "No",
      dataIndex: "PurchaseNo",
      key: "PurchaseNo",
      hidden: !isSystemUser,
      sorter: (a, b) => a?.PurchaseNo - b?.PurchaseNo,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PurchaseNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PurchaseNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Purchase Time",
      dataIndex: "PurchaseTime",
      key: "PurchaseTime",
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => new Date(a.PurchaseTime) - new Date(b.PurchaseTime),
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PurchaseTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PurchaseTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Purchase Type",
      dataIndex: "PurchaseType",
      key: "PurchaseType",
      sorter: (a, b) => a?.PurchaseType - b?.PurchaseType,
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PurchaseType"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PurchaseType",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "OEM",
      dataIndex: "Oem",
      hidden: hideColmn,
      key: "Oem",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="OemNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "OemNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Dealer",
      dataIndex: "Dealer",
      hidden: hideColmn,
      key: "Dealer",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="DealerNo"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "DealerNo",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "Total",
      dataIndex: "Total",
      key: "Total",
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="Total"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "Total",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
      render: renderPrice,
    },
    {
      title: "Payment Time",
      dataIndex: "PaymentTime",
      key: "PaymentTime",
      width: 250,
      render: (text) => <div>{text ? formatUTCTime(text) : ""}</div>,
      sorter: (a, b) => () => {},
      sortIcon: () => (
        <SortIcon
          sortOrder={modParams.order}
          columnKey="PaymentTime"
          sortBy={modParams.sort_by}
        />
      ),
      onHeaderCell: () => ({
        onClick: () =>
          setParams((prev) => ({
            ...modParams,
            sort_by: "PaymentTime",
            order: modParams.order === "desc" ? "asc" : "desc",
          })),
      }),
    },
    {
      title: "",
      fixed: "right",
      width: 0,
      align: "center",
      hidden: !canManagePurchase,
      render: (text, record, rowIndex) => {
        if (hoveredRow !== rowIndex) return null;
        if (isPurchasePaid(record)) return null;
        return (
          <div className="absolute top-2 right-5">
            <div className="bg-[#EFF0F2] duration-75 bottom-0 flex gap-2 items-center justify-center z-50">
              <Tooltip title="Delete">
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowModal(true);
                    setSelectedRowKeys([record?.PurchaseNo]);
                  }}
                  className="cursor-pointer hover:bg-gray-400 px-[5px] py-[5px] rounded-[4px] "
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
  ];
};
